import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { MessageService } from 'primeng/api';
import { catchError, throwError } from 'rxjs';

import { FormValidationErrorService } from '../services/form-validation-error.service';
import {
  markValidationErrorHandled,
  validationFromHttpError,
  validationLinesFromParsed,
} from '../utils/api-error.util';

/**
 * On 400 VALIDATION_ERROR, dispatches to an optional registered form handler.
 * Falls back to a toast when no handler is active.
 */
export const validationErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const formValidation = inject(FormValidationErrorService);
  const messages = inject(MessageService);

  return next(req).pipe(
    catchError((err: HttpErrorResponse) => {
      const parsed = validationFromHttpError(err);
      if (!parsed) {
        return throwError(() => err);
      }

      if (formValidation.dispatch(parsed)) {
        markValidationErrorHandled(err);
        return throwError(() => err);
      }

      const lines = validationLinesFromParsed(parsed);
      if (lines.length === 0) {
        markValidationErrorHandled(err);
        return throwError(() => err);
      }

      messages.add({
        severity: 'error',
        summary: lines.length === 1 ? lines[0]! : 'Validation failed',
        detail: lines.length > 1 ? lines.join('; ') : undefined,
        life: 9000,
      });

      markValidationErrorHandled(err);
      return throwError(() => err);
    }),
  );
};
